import { render, staticRenderFns } from "./datos-hijos-ext.vue?vue&type=template&id=7761ab1b&scoped=true&"
import script from "./datos-hijos-ext.ts?vue&type=script&lang=ts&"
export * from "./datos-hijos-ext.ts?vue&type=script&lang=ts&"
import style0 from "./datos-hijos-ext.vue?vue&type=style&index=0&id=7761ab1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7761ab1b",
  null
  
)

export default component.exports